import { useAppStore } from '../shared/stores/useAppStore';

export function useNumberLocale(): string {
    return useAppStore(s => s.userSettings.numberFormattingLocale);
}

export function formatFixed(
    value: number | null | undefined,
    locale: string,
    fractionDigits: number,
): string {
    if (value == null || Number.isNaN(value)) return '';
    return value.toLocaleString(locale, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}
